module.exports = __webpack_public_path__ + "static/media/cme.fb690a7b.png";